<template>
    <v-card-text
        class="indigo darken-3 white--text text-no-wrap pa-0"
        >
     
        <!-- diagnosisById -->
        <v-layout 
            align-center
            justify-start
            v-if="scope == 'diagnosisById'"
            >
            <!-- {{diagnosisById}} -->
            <v-flex md2 sm3 xs6>
                <v-card-text>
                    <b class='mr-1 indigo--text text--lighten-3'>Diagnostico:</b>
                    {{ dynamicNestedObjects(diagnosisById, 'name', { toUpperCase: true }) }}
                </v-card-text>
            </v-flex>
            <v-flex md10 sm9 xs6>
                <v-card-text>
                    <b class='mr-3 indigo--text text--lighten-3'>Performance:</b>
                    <v-progress-circular
                        :rotate="-90"
                        :size="40"
                        :width="2"
                        :height="30"
                        :value="(dynamicNestedObjects(diagnosisById, 'performance', { arrayParent: 'snapshots' }))"
                        :color="diagnosisByIdColor"
                        class="mr-3"
                        style="font-size: 0.8rem;"
                        >
                        {{ dynamicNestedObjects(diagnosisById, 'performance', { arrayParent: 'snapshots' }) }}%  
                    </v-progress-circular>
            
                    <v-chip :color="diagnosisByIdColor" style="font-size: 0.8rem;">
                        {{ diagnosisByIdText }}
                    </v-chip>
                </v-card-text>
            </v-flex>
        </v-layout>

        <!-- planningById -->
        <v-layout 
            align-center
            justify-start
            v-if="scope == 'planningById'"
            >
            <v-flex>
                <v-card-text>
                    <b class='mr-1 indigo--text text--lighten-3'>Planejamento:</b>
                    {{ dynamicNestedObjects(planningById, 'name', { toUpperCase: true }) }}
                </v-card-text>
            </v-flex>
        </v-layout>
       
        <!-- planningGoalById -->
        <v-layout 
            align-center
            justify-start
            v-if="scope == 'planningGoalById'"
            >
            <v-flex xs6 sm5 md3>
                <v-card-text>
                    <b class='mr-1 indigo--text text--lighten-3'>Planejamento:</b>
                    {{ dynamicNestedObjects(planningById, 'name', { toUpperCase: true }) }}
                </v-card-text>
            </v-flex>
            <v-flex xs6 sm7 md9>
                <v-card-text>
                    <b class='mr-1 indigo--text text--lighten-3'>Objetivo Estratégico:</b>
                    {{ dynamicNestedObjects(planningGoalById, 'goal', {}) }}
                </v-card-text>
            </v-flex>
        </v-layout>

        <!-- log -->
        <v-layout     
            align-center
            justify-start
            v-if="scope == 'log'"
            >
            <v-flex>
                <v-card-text>
                    <b class='mr-1 indigo--text text--lighten-3'>Escopo:</b>
                    {{ dynamicNestedObjects(log, 'collectionInfo.name', {}) }}
                </v-card-text>
            </v-flex>
            <v-flex>
                <v-card-text>
                    <b class='mr-1 indigo--text text--lighten-3'>Operação:</b>
                    {{ dynamicNestedObjects(log, 'operation', {}) }}
                </v-card-text>
            </v-flex>
            <v-flex success--text text--lighten-2>
                <v-card-text>
                    <b class='mr-1'>Sucessos:</b>
                    {{ dynamicNestedObjects(log, 'successCount', {}) }}
                </v-card-text>
            </v-flex>
            <v-flex error--text text--lighten-2>
                <v-card-text>
                    <b class='mr-1'>Erros:</b>
                    {{ dynamicNestedObjects(log, 'errorsCount', {}) }}
                </v-card-text>
            </v-flex>
            <v-flex>
                <v-card-text>
                    <b class='mr-1 indigo--text text--lighten-3'>Usuário:</b>
                    {{ dynamicNestedObjects(log, 'user', {}) }}
                </v-card-text>
            </v-flex>
            <v-flex>
                <v-card-text>
                    <b class='mr-1 indigo--text text--lighten-3'>Data:</b>
                    {{ dynamicNestedObjects(log, 'createdAt', { dateHour: true }) }}
                </v-card-text>
            </v-flex>
        </v-layout>

    </v-card-text>
</template>

<script>
import moment from '@/config/moment'
import { createNamespacedHelpers } from 'vuex'
const { mapState, mapGetters, mapActions } = createNamespacedHelpers('registers')

export default {
    name: 'ComponentHeader',
    props: {
        scope: String
    },
    computed: {
        ...mapGetters(['diagnosisById', 'planningById', 'planningGoalById', 'log']),

        diagnosisByIdColor() {
            return this.performanceColor(this.dynamicNestedObjects(this.diagnosisById, 'performance', {arrayParent: 'snapshots'}))
        },
        diagnosisByIdText() {
            return this.performanceText(this.dynamicNestedObjects(this.diagnosisById, 'performance', {arrayParent: 'snapshots'}))
        },
    },
    methods: {
        dynamicNestedObjects(item, key, options) {
            // console.log(item, key, options)
			if (typeof item === 'undefined') { return '' }
            if (Object.entries(item).length === 0 && item.constructor === Object && key === 'performance') { return 0 }
            if (Object.entries(item).length === 0 && item.constructor === Object) { return item }
            var obj = (options.hasOwnProperty('arrayParent')) ? item[options.arrayParent][item[options.arrayParent].length-1] : item
            key = key.split('.')
			while(key.length) {
                if(typeof obj !== 'object') return undefined
                if(Array.isArray(obj)) {
                    var array = []
                    obj.forEach((element) => {
                        array.push(element[key])
                    })
                    key.shift()
                    return array
                } else {
                    obj = obj[key.shift()]
                }
            }
            
            // Formating
            // if (options.hasOwnProperty('dateFormat')) { obj = moment(obj).format(options.dateFormat) }
            if (options.hasOwnProperty('date')) { obj = moment(obj).format("DD/MM/YYYY") }
            if (options.hasOwnProperty('dateHour')) { obj = moment(obj).format("DD/MM/YYYY - HH:mm:ss") }
            if (options.hasOwnProperty('dateYear')) { obj = moment(obj).format("YYYY") }
            if (options.hasOwnProperty('datePlusWeek')) { obj = moment(obj).format("DD/MM/YYYY, dddd") }
            if (options.hasOwnProperty('slice')) { obj = obj.slice(options.slice) }
            if (options.hasOwnProperty('toUpperCase')) { obj = obj.toUpperCase() }
            if (options.hasOwnProperty('multiplier')) { obj = obj * options.multiplier }
            return obj
        },
        performanceColor(performance) {
			let color = 'grey'

			if (performance <= 50) {
				color = 'error'
			} else if (performance <= 60) {
				color = 'warning'
			} else if (performance <= 80) {
				color = 'teal'
			} else if (performance <= 100) {
				color = 'success'
			}

			return `${color} accent-3`
        },
        performanceText(performance) {
			let text = ''
    
			if (performance <= 50) {
				text = 'Deficiente'
			} else if (performance <= 60) {
				text = 'Bom'
			} else if (performance <= 80) {
				text = 'Muito Bom'
			} else if (performance <= 100) {
				text = 'Excelente'
			}

			return text
        },
    }
}
</script>

<style>

</style>
